// assets
import { DashboardOutlined, TabletOutlined, UserOutlined, ProfileOutlined, TeamOutlined, CalendarOutlined, StarOutlined, SettingOutlined, ImportOutlined, GlobalOutlined, CalculatorOutlined, UsergroupAddOutlined, FundProjectionScreenOutlined } from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  TabletOutlined,
  ProfileOutlined,
  TeamOutlined,
  CalendarOutlined,
  UserOutlined,
  StarOutlined,
  SettingOutlined,
  ImportOutlined,
  GlobalOutlined,
  CalculatorOutlined,
  UsergroupAddOutlined,
  FundProjectionScreenOutlined
};

// Hospital tenants call their end-users "Patients". Detected from the logged-in
// company's industry (stored in userData at login/impersonation). Re-evaluated
// on each full page load, which is when login & impersonation both navigate.
const isHospitalTenant = () => {
  try {
    const u = JSON.parse(localStorage.getItem('userData') || '{}');
    const name = (u.industry_name || '').toLowerCase();
    const code = (u.industry_code || '').toUpperCase();
    return name.includes('hospital') || name.includes('clinic') || code.startsWith('HOS');
  } catch {
    return false;
  }
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

// Common dashboard item accessible to all roles
const commonDashboardItem = {
  id: 'dashboard',
  title: 'Dashboard',
  type: 'item',
  url: '/dashboard',
  icon: icons.DashboardOutlined,
  breadcrumbs: false
};

const dashboard = {
  id: 'group-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    commonDashboardItem,
    {
      id: 'Company List',
      title: 'Company List',
      type: 'item',
      url: '/companyList',
      icon: icons.TabletOutlined,
      breadcrumbs: false
    },
    {
      id: 'prospects',
      title: 'Prospects',
      type: 'item',
      url: '/prospects',
      icon: icons.ProfileOutlined,
      breadcrumbs: false
    },
    {
      id: 'cost-calculator',
      title: 'Cost Calculator',
      type: 'item',
      url: '/cost-calculator',
      icon: icons.CalculatorOutlined,
      breadcrumbs: false
    },
    {
      id: 'user-management',
      title: 'User Management',
      type: 'item',
      url: '/user-management',
      icon: icons.UsergroupAddOutlined,
      breadcrumbs: false
    },
    {
      id: 'product-deck',
      title: 'Scheduled Demos',
      type: 'item',
      url: '/product-deck',
      icon: icons.FundProjectionScreenOutlined,
      breadcrumbs: false
    },
    {
      id: 'admin-settings',
      title: 'Settings',
      type: 'item',
      url: '/admin-settings',
      icon: icons.SettingOutlined,
      breadcrumbs: false
    }
  ]
};

// Marketing Team — limited to prospects and lead companies only
const marketing = {
  id: 'group-marketing',
  title: 'Marketing',
  type: 'group',
  children: [
    {
      id: 'prospects',
      title: 'Prospects',
      type: 'item',
      url: '/prospects',
      icon: icons.ProfileOutlined,
      breadcrumbs: false
    },
    {
      id: 'leads',
      title: 'Leads',
      type: 'item',
      url: '/companyList',
      icon: icons.TabletOutlined,
      breadcrumbs: false
    },
    {
      id: 'product-deck',
      title: 'Scheduled Demos',
      type: 'item',
      url: '/product-deck',
      icon: icons.FundProjectionScreenOutlined,
      breadcrumbs: false
    }
  ]
};

const companies = {
  id: 'group-companies',
  title: 'Companies Account',
  type: 'group',
  children: [
    commonDashboardItem,
    {
      id: 'Appointments',
      title: 'Appointments',
      type: 'item',
      url: '/appointmentList',
      icon: icons.CalendarOutlined
    },
    {
      id: 'Doctors',
      title: 'Doctors',
      type: 'item',
      url: '/account/doctors',
      icon: icons.TeamOutlined
    },
    {
      id: 'userlist',
      title: isHospitalTenant() ? 'Patients' : 'User List',
      type: 'item',
      url: '/userlist',
      icon: icons.UserOutlined
    },
    {
      id: 'testimonials',
      title: 'Testimonials',
      type: 'item',
      url: '/testimonials',
      icon: icons.StarOutlined
    },
    {
      id: 'website-content',
      title: 'Website Content',
      type: 'item',
      url: '/website-content',
      icon: icons.GlobalOutlined
    },
    {
      id: 'company-settings',
      title: 'Company Settings',
      type: 'item',
      url: '/company-settings',
      icon: icons.SettingOutlined
    },
    {
      id: 'import-bookings',
      title: 'Import Appointments',
      type: 'item',
      url: '/import-bookings',
      icon: icons.ImportOutlined
    }
  ]
};

export { dashboard, companies, marketing, commonDashboardItem };
